import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { budgetFormat, numberThousandSeparator } from '../../../utils/formatterUtil'
import { dispayTableNumbers } from '../../../utils/dataUtil'

export default function AssetCountingTable({
  schema,
  loading,
  isViewMode,
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},
  onSelect = () => {},
  isSupplyOfficer,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [tableData, setTableData] = useState([])
  // const [displayLength, setDisplayLength] = useState(pageNumber)
  // const [page, setPage] = useState(pageSize)

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    // setPage(1)
    // setDisplayLength(dataKey)

    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    // setPage(dataKey)

    onReload(dataKey, displayLength)
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
        data={tableData || []}
        style={{ marginTop: '20px' }}
      >
        <Column width={100} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              // return index + 1
              return dispayTableNumbers(page, displayLength, index)
            }}
          </Cell>
        </Column>

        <Column minWidth={250} flexGrow={1}>
          <HeaderCell>เลขที่ตรวจนับ</HeaderCell>
          <Cell dataKey="stockCountNo" />
        </Column>

        <Column width={180} align="center">
          <HeaderCell>ปีงบประมาณ</HeaderCell>
          <Cell dataKey="budgetYear" />
        </Column>

        {/* <Column width={150} minWidth={150} flexGrow={1}>
          <HeaderCell>ประเภทการขอปิด</HeaderCell>
          <Cell dataKey="closureType" />
        </Column> */}

        {/* <Column width={140}>
          <HeaderCell>วันที่ขอปิด</HeaderCell>
          <Cell dataKey="requestDate" />
        </Column> */}

        <Column width={180} align="right">
          <HeaderCell>จำนวนครุภัณฑ์</HeaderCell>
          <Cell>
            {(rowData) => {
              return <span>{numberThousandSeparator(rowData.totalAsset || 0)}</span>
            }}
          </Cell>
        </Column>

        <Column width={250} align="right">
          <HeaderCell>รวมมูลค่า</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.price)
            }}
          </Cell>
        </Column>

        <Column width={300} align="center">
          <HeaderCell>สถานะตรวจนับ</HeaderCell>
          <Cell dataKey="statusName" />
        </Column>

        {!isViewMode && (
          <Column width={120} align="center" fixed="right">
            <HeaderCell>จัดการรายการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <SaveButton
                    icon="eye"
                    onClick={() => {
                      onSelect(rowData)
                    }}
                  >
                    แสดง
                  </SaveButton>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
